import { Word } from '@app-types/KuranTypes'
import Tooltip from '@components/shared/Tooltip/Tooltip'
import classNames from 'classnames'

type AyahComponentType = {
  i: number
  word: Word
  ayahNo: number
  hideMeal: boolean
  hideTooltip: boolean
}

function AyahComponent({ i, word, hideMeal, hideTooltip, ayahNo }: AyahComponentType) {
  return (
    <div key={i} className="mx-1 my-2 text-center ayah">
      <Tooltip trigger="click" placement='top' disabled={!hideMeal || hideTooltip} content={word.meal}>
        <div
          data-word-ayah-id={ayahNo}
          className={classNames('ayah-arabic my-1', {
            'cursor-help hover:text-lime-600': hideMeal && !hideTooltip,
          })}
        >
          <span>{word.arapca}</span>
        </div>
      </Tooltip>
      <div className={classNames('ayah-meal', { hidden: hideMeal })}>
        <span>{word.meal}</span>
      </div>
    </div>
  )
}

export default AyahComponent
